var plugin_rtlignore_default = {
  "alignLeft": "-HvA4",
  "textWrapNowrap": "ZW-nB",
  "alignRight": "nDv8M",
  "alignCenter": "_0F0d3",
  "sizeFullWidth": "LZ21t",
  "renderedInTable": "-HB2h",
  "sizeOriginal": "_8Ts42",
  "sizeContent": "tgIXc",
  "sizeSmall": "p135k",
  "sizeSmallCenter": "MCuX-",
  "flex": "Cp8I1",
  "atomic": "F6HkU",
  "embed": "zQTT9",
  "horizontalScrollbar": "DZ9a7",
  "pluginContainerMobile": "LUhKx"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
